/**
 * complete use: *ifRole="admin; condition: true"
 * short use: *ifRole
 * no admin use: *ifRole="'operator'"
 */
import { ChangeDetectorRef, Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { filter, take, tap } from 'rxjs/operators';

import { environment } from '@environments/environment';

@Directive({
  selector: '[ifRole]'
})
export class IfRoleDirective implements OnInit {
  role: string;
  @Input('ifRole') set checkRole(data: string) {
    this.role = (data) ? data : environment.adminRole;
  }
  @Input() ifRoleCondition = true;

  constructor(
    private cd: ChangeDetectorRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef) { }

  ngOnInit() {
    /*this.authFacadeService.roles$.pipe(
      tap(() => this.viewContainer.clear()),
      filter((role) => role !== undefined),
      filter((role) => role.filter((item) => item.role === this.role).length),
      filter(() => this.ifRoleCondition),
      tap(() => this.viewContainer.createEmbeddedView(this.templateRef)),
      tap(() => this.cd.markForCheck()),
      take(1)
    ).subscribe();*/
  }

}
